export const addAuthToFetchOpts = (accessToken, options, timeout = 300000) => {
  options.headers = options?.headers || {};
  options.headers['Authorization'] = `Bearer ${accessToken}`;
  options.timeout = timeout;
  return options;
}

export const addAuthToAxiosOpts = addAuthToFetchOpts;
